import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgGuacModeBadge',
})
export default class CmgGuacModeBadge extends Vue {

  get guacModePepperImageUrl(): string {
    return this.$appStore.state.cms.images.icons.guacModePepperBadge.default;
  }
}
